import {ShortcutType} from '@/types/enums/ShortcutType';
import {KeyControlSetting} from '@/components/deploymentAutocomplete/types';

export const DEFAULT_VISIBLE_DAYS: number = 7;

export const DEFAULT_SHORTCUTS: Record<ShortcutType, KeyControlSetting> = {
    [ShortcutType.copy]: {key: 'c', ctrlKey: true, shiftKey: false, altKey: false, metaKey: false},
    [ShortcutType.paste]: {key: 'v', ctrlKey: true, shiftKey: false, altKey: false, metaKey: false},
    [ShortcutType.cut]: {key: 'x', ctrlKey: true, shiftKey: false, altKey: false, metaKey: false},
    [ShortcutType.editDeployment]: {key: 'b', ctrlKey: true, shiftKey: false, altKey: false, metaKey: false},
    [ShortcutType.newDeployment]: {key: 'd', ctrlKey: true, shiftKey: false, altKey: false, metaKey: false},
    [ShortcutType.normal]: {key: 'm', ctrlKey: true, shiftKey: false, altKey: false, metaKey: false},
    [ShortcutType.free]: {key: 'l', ctrlKey: true, shiftKey: false, altKey: false, metaKey: false},
    [ShortcutType.sick]: {key: 'z', ctrlKey: true, shiftKey: false, altKey: false, metaKey: false},
    [ShortcutType.extra]: {key: 'q', ctrlKey: true, shiftKey: false, altKey: false, metaKey: false},
    [ShortcutType.training]: {key: 'i', ctrlKey: true, shiftKey: false, altKey: false, metaKey: false},
    [ShortcutType.compensationLeave]: {key: 's', ctrlKey: true, shiftKey: false, altKey: false, metaKey: false},
    [ShortcutType.specialLeave]: {key: 'a', ctrlKey: true, shiftKey: false, altKey: false, metaKey: false},
};

export const DEFAULT_BEGIN_DATE: number = -3600000;
export const DEFAULT_END_DATE: number = 1893366000000;
export const DEFAULT_PAGE_TITLE: string = 'Planbord - Roosterplanning';
